import script from "./OrderHandlingCard.vue?vue&type=script&setup=true&lang=js"
export * from "./OrderHandlingCard.vue?vue&type=script&setup=true&lang=js"

import "./OrderHandlingCard.vue?vue&type=style&index=0&id=2ec45c46&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2ec45c46"]])

export default __exports__